import type { IdeaMode } from "@mycompbox/shared";
import { api } from "./client";

/**
 * Authenticated user profile returned by GET /api/v1/me.
 *
 * This intentionally does NOT extend the shared `User` type — the `/me`
 * endpoint returns only the safe-to-display profile fields. It also omits
 * team-membership fields like `role`/`teamId` which are surfaced via
 * separate endpoints.
 */
export interface Me {
  id: string;
  email: string;
  name: string;
  avatarUrl: string | null;
  timeZone: string | null;
  /** How this person's ideas move after approval by default (ER-145); null = Manual. */
  ideaModeDefault?: IdeaMode | null;
  isActive: boolean;
  isGlobalAdmin: boolean;
  createdAt: string;
  updatedAt: string;
}

interface MeResponse {
  data: Me;
}

export const meApi = {
  /**
   * Get current user information
   */
  me: () => api.get<MeResponse>("/me"),
};
